export enum CertificateDialogs {
  SelectTemplate = 'SELECT_TEMPLATE',
  AttachCertificate = 'ATTACH_CERTIFICATE',
  DeleteCertificate = 'DELETE_CERTIFICATE',
  SelectedCertificate = 'SELECTED_CERTIFICATE',
}
